import {defineStore} from "pinia"
import ApiService from "~/services/ApiService";

export const useFooterStore = defineStore('footer', () => {
    const {$api} = useNuxtApp();

    const state = reactive({
        regulation: null,
    })

    const regulation = computed(() => {
        return state.regulation;
    })

    const store = async () => {
        return ApiService.get('/api/regulation').then(res => {
            state.regulation = res.data;
        });
    }

    return {
        state,
        regulation,
        store,
    }
})
